import { Component, OnInit } from '@angular/core';
import { DeviceService } from '../../services/device.service';

@Component({
  selector: 'app-root',
  template: `
    <div>
      <p>Device Info: {{ deviceInfo }}</p>
      <p>Location: {{ location }}</p>
    </div>
  `,
  standalone: false
})
export class DeviceInfoComponent implements OnInit {
  deviceInfo?: string;
  location?: string;

  constructor(private deviceService: DeviceService) { }

  async ngOnInit() {
    this.deviceInfo = await this.deviceService.getDeviceInfo();
    this.location = await this.deviceService.getLocation();
  }
}